import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import { InfoWindow } from "google-maps-react";
import mapStyle from "../constants/mapStyle";
import Geocode from "react-geocode";
import wholesaleCustomersNear from "../api/wholesaleCustomersNear";
import CircularProgress from "@material-ui/core/CircularProgress";
import makeLowercaseKeys from "../helpers/lowercaseKeys";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Link from "./../components/Link";
import { theme } from "./../theme";
import { ThemeProvider } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as WebsiteIcon } from "../images/icons/ico-website.svg";
import { ReactComponent as LocationIcon } from "../images/icons/ico-location.svg";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import mapIcon1 from "../images/icons/map-markers/LightBlue.svg";
import mapIcon2 from "../images/icons/map-markers/Lilac.svg";
import mapIcon3 from "../images/icons/map-markers/Purple.svg";
import mapIcon4 from "../images/icons/map-markers/Red.svg";
import mapIcon5 from "../images/icons/map-markers/Yellow.svg";
import ProviderWithRouter from "../ProviderWithRouter";
import cx from "classnames";
import {
  getStoresPage,
  mergeAndSortStores,
} from "../helpers/customHempRetailers";

const apiKey = "AIzaSyBuLWEJhtMCAW-R9qP1l019HbheUR3DqRw";
const markerRefs = [];

const mapIcons = [mapIcon1, mapIcon2, mapIcon3, mapIcon4, mapIcon5];

class StoreLocatorPage extends Component {
  static defaultProps = {
    brand: "Good News",
    customStyles: false,
    customStores: [],
    customStoresLoading: false,
  };
  state = {
    activeMarker: null,
    activeID: null,
    infoWindowVisible: false,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416,
    },
    mapRef: null,
    stores: null,
    allStores: null,
    zip: null,
    enableGeolocation: false,
    infoMessage: false,
    page: 1,
    totalPages: false,
    searchLocation: "Chicago, IL",
    limit: 20,
    offset: 0,
    loading: true,
    searchLocationCoords: false,
    zoom: 5,
    renderedOnce: false,
  };

  hasCustomStores = () =>
    Array.isArray(this.props.customStores) && this.props.customStores.length > 0;

  fetchWholesaleCustomers = (limit, offset) =>
    wholesaleCustomersNear(
      this.state.searchLocation,
      this.props.brand,
      limit,
      offset,
    );

  getWholesaleCustomerData = async () => {
    if (!this.hasCustomStores()) {
      return this.fetchWholesaleCustomers(this.state.limit, this.state.offset);
    }

    const initialData = await this.fetchWholesaleCustomers(1, 0);
    const totalRows = Number(initialData && initialData.total_rows) || 0;

    if (totalRows <= 1) {
      return initialData;
    }

    return this.fetchWholesaleCustomers(
      Math.max(totalRows, this.state.limit),
      0,
    );
  };

  getApiStores = (data) => {
    const rows = Array.isArray(data && data.data) ? data.data : [];
    const stores = makeLowercaseKeys(rows).filter(
      (el) =>
        !el.hidden &&
        el.name !== "Urban Buds - Distro" &&
        !(el.id || "").includes("C-003769"),
    );

    if (this.props.brand === "Good News") {
      stores.push({
        id: "C-002598.277716",
        name: "JDM Cannabis - Mendon",
        address: "103 Uxbridge Road Mendon",
        city: "Mendon",
        zip: "01756",
        state: "MA",
        lat: 42.0964572,
        lng: -71.5794657,
      });
    }

    stores.forEach((store) => {
      if (store.delivery_only === true) {
        store.name = store.name;
        store.address = null;
        store.zip = null;
        store.state = null;
        store.url = store.url;
      }
      if (store.id === "C-001397.14136") {
        store.url = "https://trydoobie.com/goodnews";
      }
    });

    return stores;
  };

  getFallbackSearchLocationCoords = async () => {
    try {
      const response = await Geocode.fromAddress(this.state.searchLocation);
      const location = response.results[0].geometry.location;

      return {
        lat: location.lat,
        lng: location.lng,
      };
    } catch (error) {
      return this.state.initialCenter;
    }
  };

  getSearchLocationCoords = async (stores) => {
    const nearLat = stores[0] && Number(stores[0].near_lat);
    const nearLng = stores[0] && Number(stores[0].near_lng);

    if (Number.isFinite(nearLat) && Number.isFinite(nearLng)) {
      return {
        lat: nearLat,
        lng: nearLng,
      };
    }

    return this.getFallbackSearchLocationCoords();
  };

  getStores = async () => {
    if (this.props.customStoresLoading) {
      return;
    }

    const data = await this.getWholesaleCustomerData();
    const apiStores = this.getApiStores(data);
    const searchLocationCoords = await this.getSearchLocationCoords(apiStores);
    const hasCustomStores = this.hasCustomStores();
    const allStores = hasCustomStores
      ? mergeAndSortStores(
          apiStores,
          this.props.customStores,
          searchLocationCoords,
        )
      : apiStores;
    const stores = hasCustomStores
      ? getStoresPage(allStores, this.state.page, this.state.limit)
      : allStores;

    this.setState({
      stores: stores,
      allStores: hasCustomStores ? allStores : null,
      infoMessage: `Showing stores closest to ${this.state.searchLocation}`,
      totalPages: hasCustomStores
        ? Math.ceil(allStores.length / this.state.limit)
        : Math.floor((Number(data && data.total_rows) || 0) / this.state.limit),
      loading: false,
      bounds: this.getMapBounds(stores, searchLocationCoords),
      searchLocationCoords: searchLocationCoords,
    });
  };

  componentDidMount() {
    //set up google
    Geocode.setApiKey(apiKey);
    Geocode.setLanguage("en");
    Geocode.setRegion("es");
    // Geocode.enableDebug();

    //wait for wholesale customer data from api then set state.stores to it
    this.getStores();
  }

  componentDidUpdate(prevProps, prevState) {
    // re-fit the map to the markers only when the bounds actually change
    // (new search / page change) or when the map first becomes available.
    // Doing this on every render would reset the zoom on each marker click.
    if (
      this.state.bounds &&
      (prevState.bounds !== this.state.bounds ||
        prevState.mapRef !== this.state.mapRef)
    ) {
      this.fitMapToBounds();
    }

    //the pagination is driven by offset, so we check to see if it changed, and re-run our api call
    if (this.props.customStoresLoading) {
      return;
    }

    if (
      this.state.offset !== prevState.offset ||
      this.state.searchLocation !== prevState.searchLocation ||
      this.props.brand !== prevProps.brand ||
      this.props.customStoresLoading !== prevProps.customStoresLoading ||
      this.props.customStores !== prevProps.customStores
    ) {
      this.getStores();
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  setCustomStoresPage(page) {
    const stores = getStoresPage(
      this.state.allStores || [],
      page,
      this.state.limit,
    );

    this.setState({
      activeMarker: null,
      activeID: null,
      infoWindowVisible: false,
      page: page,
      loading: false,
      stores: stores,
      bounds: this.getMapBounds(stores, this.state.searchLocationCoords),
    });
  }

  nextPage() {
    if (this.state.page + 1 <= this.state.totalPages) {
      const offset = this.state.page * this.state.limit;

      if (this.hasCustomStores() && this.state.allStores) {
        this.setCustomStoresPage(this.state.page + 1);
        return;
      }

      this.setState({
        infoWindowVisible: false,
        offset: offset,
        page: this.state.page + 1,
        loading: true,
      });
    }
  }

  prevPage() {
    if (this.state.page - 1 !== 0) {
      const offset = (this.state.page - 2) * this.state.limit;

      if (this.hasCustomStores() && this.state.allStores) {
        this.setCustomStoresPage(this.state.page - 1);
        return;
      }

      this.setState({
        infoWindowVisible: false,
        offset: offset,
        page: this.state.page - 1,
        loading: true,
      });
    }
  }

  getCurrentLocation = () => {
    const options = {
      enableHighAccuracy: false,
      timeout: 10 * 1000,
      maximumAge: 5 * 60 * 1000,
    };
    const success = (pos) => {
      const crd = pos.coords;
      let zip = false;
      Geocode.fromLatLng(crd.latitude, crd.longitude).then(
        (response) => {
          for (
            let i = 0;
            i < response.results[0].address_components.length;
            i++
          ) {
            for (
              let j = 0;
              j < response.results[0].address_components[i].types.length;
              j++
            ) {
              switch (response.results[0].address_components[i].types[j]) {
                case "postal_code":
                  zip = response.results[0].address_components[i].long_name;
                  break;
                default:
                  break;
              }
            }
          }
          this.setState({
            searchLocation: zip,
            zip: zip,
            offset: 0,
            page: 1,
            loading: true,
          });
        },
        (error) => {
          this.setState({
            infoMessage:
              "Could not get your location. Please search by Zip Code",
            loading: false,
          });
        },
      );
    };
    const error = (err) => {
      this.setState({
        infoMessage: "Could not get your location. Please search by Zip Code",
        loading: false,
      });
    };
    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  getMapBounds = (stores, locationMarkerCoords) => {
    const { google } = this.props;
    let bounds = new google.maps.LatLngBounds();

    for (let store of stores) {
      if (store.lat && store.lng) {
        bounds.extend({ lat: store.lat, lng: store.lng });
      }
    }

    const locationLat = Number(locationMarkerCoords && locationMarkerCoords.lat);
    const locationLng = Number(locationMarkerCoords && locationMarkerCoords.lng);

    if (Number.isFinite(locationLat) && Number.isFinite(locationLng)) {
      bounds.extend({
        lat: locationLat,
        lng: locationLng,
      });
    }

    return bounds;
  };

  handleMarkerClick = (props, marker) => {
    this.setState({
      activeMarker: marker,
      activeID: props.id,
      zoom: 18,
      infoWindowVisible: true,
    });
  };

  handleListItemClick = (event) => {
    const markerToShow = markerRefs.find(
      (el) => el.props.id === event.currentTarget.id.toString(),
    );

    if (!markerToShow) {
      return;
    }

    this.setState({
      activeMarker: markerToShow.marker,
      activeID: markerToShow.props.id,
      infoWindowVisible: true,
    });
  };

  // panMapTo = (map, lat, lng) => {
  //   this.map = map.map;
  //   this.map.setCenter({
  //     lat: lat,
  //     lng: lng,
  //   });
  //   this.map.setZoom(17);
  // };

  setMarkerRef = (ref) => {
    markerRefs.push(ref);
  };

  setMapRef = (ref) => {
    if (ref && !this.state.mapRef) {
      this.setState({ mapRef: ref });
    }
  };

  fitMapToBounds = () => {
    if (this.state.mapRef && this.state.mapRef.map && this.state.bounds) {
      this.state.mapRef.map.fitBounds(this.state.bounds);
      this.state.mapRef.map.panToBounds(this.state.bounds);
    }
  };

  renderCurrentLocationMarker = () => {
    const lat = Number(this.state.searchLocationCoords.lat);
    const lng = Number(this.state.searchLocationCoords.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    return (
      <Marker
        position={{
          lat: lat.toString(),
          lng: lng.toString(),
        }}
        zIndex={1000000000}
      />
    );
  };

  renderLocations = () => {
    return this.state.stores.map((store, index) => (
      <div
        key={index}
        id={store.id}
        onClick={this.handleListItemClick}
        className={`single-location ${
          this.state.activeID && this.state.activeID === store.id
            ? "active"
            : "not-active"
        }`}
      >
        <div className="store-information">
          <h2 className="store-name">{store.name}</h2>
          {!store.delivery_only ? (
            <p className="store-address">
              {store.address}, {store.city}, {store.state}
            </p>
          ) : (
            <p className="store-address">Delivery Only</p>
          )}

          {!store.delivery_only &&
            (store.miles ? (
              <p className="distance">{Math.round(store.miles)} miles away</p>
            ) : (
              <p className="distance">Less than a mile away</p>
            ))}
          {store.usage_type && store.usage_type === "Rec" && (
            <p className="usage-type">Adult Use</p>
          )}
          {store.usage_type && store.usage_type === "Med" && (
            <p className="usage-type">Medical</p>
          )}
          {store.usage_type && store.usage_type === "Both" && (
            <p className="usage-type">Medical and Adult Use</p>
          )}
        </div>

        <div className="store-actions">
          {store.url && (
            <Link
              className="icon-button"
              url={store.url}
              rel="noopener noreferrer"
              target="_blank"
              title={store.url}
            >
              <WebsiteIcon />
              Website
            </Link>
          )}

          {!store.delivery_only && (
            <Link
              className="icon-button"
              url={`https://www.google.com/maps/dir/?api=1&destination=${store.address},${store.city},${store.state},${store.zip}`}
              rel="noopener noreferrer"
              target="_blank"
              title="Directions"
            >
              <LocationIcon />
              Directions
            </Link>
          )}
        </div>
      </div>
    ));
  };

  renderMarkers = () => {
    let count = 0;
    return this.state.stores.map((store, i) => {
      const marker = (
        <Marker
          key={i}
          id={store.id}
          position={{
            lat: store.lat && store.lat.toString(),
            lng: store.lng && store.lng.toString(),
          }}
          icon={mapIcons[count]}
          onClick={this.handleMarkerClick}
          ref={this.setMarkerRef}
        />
      );
      count++;

      if (count === 5) {
        count = 0;
      }
      return marker;
    });
  };

  renderInfoWindowData = (id) => {
    const store = this.state.stores.find((el) => el.id === id);

    if (!store) {
      return <></>;
    }
    const directionsLink =
      store &&
      !store.delivery_only &&
      `https://www.google.com/maps/dir/Current+Location/${store.lat},${store.lng}`;

    return (
      store && (
        <ProviderWithRouter>
          <ThemeProvider theme={theme}>
            <div className="info-window-content">
              <h2 className="store-name">{store.name}</h2>
              {store.usage_type && store.usage_type === "Rec" && (
                <p className="usage-type">Adult Use</p>
              )}
              {store.usage_type && store.usage_type === "Med" && (
                <p className="usage-type">Medical</p>
              )}
              {store.usage_type && store.usage_type === "Both" && (
                <p className="usage-type">Medical and Adult Use</p>
              )}

              {!store.delivery_only ? (
                <p className="store-address">
                  {store.address}, {store.city}, {store.state}
                </p>
              ) : (
                <p className="store-address">Delivery Only</p>
              )}

              {directionsLink && (
                <Link
                  url={directionsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    disableElevation
                    className="mr-5"
                  >
                    Directions
                  </Button>
                </Link>
              )}

              {store.url && (
                <Link url={store.url} target="_blank" rel="noopener noreferrer">
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    disableElevation
                    className="mr-5"
                  >
                    Visit Website
                  </Button>
                </Link>
              )}
            </div>
          </ThemeProvider>
        </ProviderWithRouter>
      )
    );
  };

  handleSearchForm = (e) => {
    e.preventDefault();
    if (this.state.zip === null || this.state.zip === "") {
      this.setState({
        infoMessage: "Please enter a zip code",
      });
      return false;
    }
    this.setState({
      searchLocation: this.state.zip,
      offset: 0,
      page: 1,
      loading: true,
    });
  };

  handleLocation = () => {
    this.getCurrentLocation();
    this.setState({
      loading: true,
      infoMessage: "Getting your current location...",
    });
  };

  render() {
    const { google } = this.props;
    const {
      activeMarker,
      activeID,
      infoWindowVisible,
      stores,
      infoMessage,
      page,
      totalPages,
      loading,
      searchLocationCoords,
    } = this.state;

    const customStyles = this.props.customStyles;

    if (!stores) {
      return (
        <div
          className={cx("loading-screen", customStyles && "custom-map-loader")}
        >
          <CircularProgress
            style={{
              position: customStyles ? "static" : "absolute",
              color: "#e0fc01",
              top: "calc(50% - 25px)",
              left: "calc(50% - 25px)",
              width: "50px",
              height: "50px",
            }}
          />
        </div>
      );
    }
    return (
      stores && (
        <div className={customStyles && "custom-map"}>
          <div className="map-wrapper">
            <Map
              ref={(ref) => this.setMapRef(ref)}
              google={google}
              position="relative"
              className="interactive-map"
              zoomControl={true}
              mapTypeControl={false}
              scaleControl={true}
              rotateControl={true}
              scrollwheel={false}
              fullscreenControl={false}
              streetViewControl={true}
              gestureHandling="greedy"
              zoom={18}
              styles={mapStyle}
            >
              {this.renderMarkers()}

              {searchLocationCoords && this.renderCurrentLocationMarker()}

              <InfoWindow
                marker={activeMarker}
                visible={infoWindowVisible}
                children={this.renderInfoWindowData(activeID)}
              />
            </Map>

            <div
              className={cx(
                "locations-list-wrapper",
                customStyles && "custom-map",
              )}
            >
              <div className="locations-search-form-wrapper">
                <h3 className="locations-list-title">
                  Find Your {this.props.brand}
                </h3>
                <form
                  className="locations-search-form"
                  onSubmit={this.handleSearchForm}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={6}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <TextField
                        className="mt-10"
                        id="zip-code"
                        placeholder="Zip Code"
                        variant="outlined"
                        color="secondary"
                        required={true}
                        onChange={(event) =>
                          this.setState({ zip: event.target.value })
                        }
                        size="small"
                        style={{ width: "100%" }}
                        InputLabelProps={{
                          shrink: false,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} style={{ display: "flex" }}>
                      <Button
                        disableElevation={true}
                        variant="contained"
                        color="primary"
                        onClick={this.handleSearchForm}
                        size="small"
                        style={{ alignSelf: "center", marginLeft: "10px" }}
                      >
                        Search
                      </Button>

                      <IconButton
                        onClick={this.handleLocation}
                        className="ml-10"
                        color="secondary"
                        variant="contained"
                      >
                        <MyLocationIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </form>
              </div>

              {infoMessage && <div className="info-message">{infoMessage}</div>}

              {page && totalPages > 1 && (
                <div className="pagination-nav">
                  <div className="page-number">
                    Page {page} of {totalPages}
                  </div>
                  <div className="page-controls">
                    <span onClick={() => this.prevPage()}>Previous</span>
                    <span onClick={() => this.nextPage()}>Next</span>
                  </div>
                </div>
              )}

              <div className="locations-list">
                {loading ? (
                  <CircularProgress
                    style={{
                      position: "absolute",
                      color: "white",
                      top: "calc(50% - 25px)",
                      left: "calc(50% - 25px)",
                      width: "50px",
                      height: "50px",
                    }}
                  />
                ) : (
                  this.renderLocations(stores)
                )}
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

export default GoogleApiWrapper({
  apiKey: apiKey,
})(StoreLocatorPage);
